// extracted by css-extract-rspack-plugin
export default {"feed":"u3Ce8","loader_override":"tMCEi","loaderOverride":"tMCEi","#":"AE0zq"};